import { render, staticRenderFns } from "./ChatIndex.vue?vue&type=template&id=744f0db1&scoped=true&"
import script from "./ChatIndex.vue?vue&type=script&lang=js&"
export * from "./ChatIndex.vue?vue&type=script&lang=js&"
import style0 from "./ChatIndex.vue?vue&type=style&index=0&id=744f0db1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f0db1",
  null
  
)

export default component.exports